import { useQuery } from '@tanstack/react-query';

import { getLayoutGoalReport, LayoutGoalReportParams } from '@data';
import { activeUserIdAtom, useEnsureAtomValue } from '@store';

import { queryKeys } from '../../queryKeys';

export const useLayoutGoalReport = (goalReportParams: LayoutGoalReportParams) => {
    const activeUserId = useEnsureAtomValue(activeUserIdAtom);
    return useQuery({
        queryKey: queryKeys.goals.report(activeUserId, goalReportParams.layoutId, goalReportParams),
        queryFn: () => getLayoutGoalReport(goalReportParams),
        placeholderData: (previousData) => previousData,
    });
};
